<template>
  <div class="modal" ref="modal" v-bind:class="{ 'is-active': is_active }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("tournament") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="columns">
            <div class="column is-one-third">
              <div class="field">
                <label class="label">{{ $t("date") }}</label>
                <generic-calendar
                  type="date"
                  display_mode="dialog"
                  ref="date_calendar"
                  @selected="date_changed"
                />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("place") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.place" />
                </div>
              </div>
            </div>
            <div class="column" v-if="meta.settings">
              <div class="field">
                <label class="label">{{ $t("number of players") }}</label>
                <div class="control">
                  <div class="buttons">
                    <div
                      class="button"
                      v-bind:class="{
                        'is-primary': meta.settings.number_of_players == 4,
                      }"
                      @click="meta.settings.number_of_players = 4"
                    >
                      4
                    </div>
                    <div
                      class="button"
                      v-bind:class="{
                        'is-primary': meta.settings.number_of_players == 8,
                      }"
                      @click="meta.settings.number_of_players = 8"
                    >
                      8
                    </div>
                    <div
                      class="button"
                      v-bind:class="{
                        'is-primary': meta.settings.number_of_players == 16,
                      }"
                      @click="meta.settings.number_of_players = 16"
                    >
                      16
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="container"
              v-if="meta.settings && meta.settings.players"
            >
              <div class="grid">
                <div
                  class="cell"
                  v-for="(player, pidx) in meta.settings.players"
                >
                  <div class="field">
                    <label class="label"
                      >{{ $t("player") }} {{ pidx + 1 }}</label
                    >
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.players[pidx]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <four-people
                v-if="
                  meta.settings &&
                  meta.settings.number_of_players &&
                  meta.settings.number_of_players == 4
                "
                :players="meta.settings.players"
                ref="four_people"
              />
              <eight-people
                v-if="
                  meta.settings &&
                  meta.settings.number_of_players &&
                  meta.settings.number_of_players == 8
                "
                :players="meta.settings.players"
                ref="eight_people"
              />
              <sixteen-people
                v-if="
                  meta.settings &&
                  meta.settings.number_of_players &&
                  meta.settings.number_of_players == 16
                "
                :players="meta.settings.players"
                ref="sixteen_people"
              />
            </div>
          </div>
        </form>
      </section>
      <footer class="modal-card-foot">
        <div class="buttons">
          <button
            class="button is-primary is-rounded"
            @click="save"
            :disabled="is_form_invalid"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            <span class="icon">
              <i class="fa fa-close"></i>
            </span>
            <span>{{ $t("close") }}</span>
          </button>
          <button
            class="button is-rounded"
            @click="randomize"
            :disabled="
              !meta.settings ||
              !meta.settings.number_of_players ||
              !meta.settings.players
            "
          >
            <span class="icon">
              <i class="fa fa-random"></i>
            </span>
            <span>{{ $t("shuffle players") }}</span>
          </button>
        </div>
      </footer>
    </div>

    <!-- <button
      class="modal-close is-large"
      aria-label="close"
      @click="close_modal"
    ></button> -->
  </div>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  system_settings,
} from "@/utils";
import moment from "moment";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import FourPeople from "./FourPeople.vue";
import EightPeople from "./EightPeople.vue";
import SixteenPeople from "./SixteenPeople.vue";

export default {
  name: "TournamentModal",
  components: {
    GenericCalendar,
    FourPeople,
    EightPeople,
    SixteenPeople,
  },
  data() {
    return {
      is_active: false,
      system_settings,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.date ||
        !v.meta.place ||
        (v.meta.settings && !v.meta.settings.number_of_players)
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = false;
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = true;
    },
    view_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/tournament/pool", { uuid: uuid })
        .then((tournament) => {
          v.meta = tournament;
          v.is_active = true;

          if (tournament && tournament.date)
            v.$refs.date_calendar.set_date(tournament.date);

          if (
            tournament &&
            tournament.settings &&
            tournament.settings.number_of_players == 4
          ) {
            setTimeout(() => {
              v.$refs.four_people.set_results(tournament.settings.results);
            }, 100);
          } else if (
            tournament &&
            tournament.settings &&
            tournament.settings.number_of_players == 8
          ) {
            setTimeout(() => {
              v.$refs.eight_people.set_results(tournament.settings.results);
            }, 100);
          } else if (
            tournament &&
            tournament.settings &&
            tournament.settings.number_of_players == 16
          ) {
            setTimeout(() => {
              v.$refs.sixteen_people.set_results(tournament.settings.results);
            }, 100);
          } else {
            console.log("SDFSFSDF", tournament.settings);
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      let results = {};
      if (v.meta.settings.number_of_players == 4)
        results = v.$refs.four_people.get_results();
      else if (v.meta.settings.number_of_players == 8)
        results = v.$refs.eight_people.get_results();
      else if (v.meta.settings.number_of_players == 16)
        results = v.$refs.sixteen_people.get_results();
      v.meta.settings.results = results;
      if (!v.meta.uuid)
        put("/tournament/pool", v.meta)
          .then(() => {
            v.$emit("success");
            v.is_active = false;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/tournament/pool", v.meta)
          .then(() => {
            v.$emit("success");
            v.is_active = false;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        date: "",
        place: "",
        settings: {
          number_of_players: "",
          players: [],
        },
      };
      v.error = "";
    },
    date_changed(date) {
      let v = this;
      v.meta.date = moment(
        date,
        v.system_settings.enterprise_settings.date_format
      );
    },
    randomize() {
      let v = this;
      let players = v.meta.settings.players.map((p) => {
        let res = "";
        for (let i = 0; i < 6; i++) {
          const random = Math.floor(Math.random() * 27);
          res += String.fromCharCode(97 + random);
        }
        return p || res;
      });
      let new_players = [];
      while (players.length > 0) {
        let idx = Math.floor(Math.random() * players.length);
        new_players.push(players[idx]);
        players.splice(idx, 1);
      }
      v.meta.settings.players = new_players;
    },
  },
  mounted() {
    // let v = this;
  },
  watch: {
    "meta.settings.number_of_players": function (val) {
      let v = this;

      if (v.meta && v.meta.settings) {
        let bkp = JSON.parse(JSON.stringify(v.meta.settings.players));
        v.meta.settings.players = [];

        for (let i = 0; i < val; i++) {
          let bk = bkp[i];
          v.meta.settings.players.push(bk || "");
        }
      }
    },
  },
};
</script>
<style scoped>
.modal-card {
  width: 90%;
}
</style>
